import React from 'react';
import ClassNames from 'classnames';
import Paper from 'components/paper/Paper';
import EnhancedSwitch from 'components/forms/enhanced-switch/EnhancedSwitch';

export default React.createClass({



  propTypes: {
    onToggle: React.PropTypes.func,
    toggled: React.PropTypes.bool,
    defaultToggled: React.PropTypes.bool,
    labelPosition: React.PropTypes.bool,

  },

  render() {
    let {
      onToggle,
    } = this.props;

    let toggleElement = (
      <div>
        <div className="lui-toggle-track" />
        <Paper className="lui-toggle-thumb" zDepth={1}/>
      </div>
    );

    let enhancedSwitchProps = {
      ref: "enhancedSwitch",
      inputType: "checkbox",
      switchElement: toggleElement,
      className: "lui-toggle",
      iconClassName: "lui-toggle-icon",
      onSwitch: this._handleToggle,
      defaultSwitched: this.props.defaultToggled,
      labelPosition: (this.props.labelPosition) ? this.props.labelPosition : this.props.labelPosition
    };

    if (this.props.hasOwnProperty('toggled')) enhancedSwitchProps.checked = this.props.toggled;

    return (
      <EnhancedSwitch
        {...this.props}
        {...enhancedSwitchProps}/>
    );
  },

  isToggled() {
    return this.refs.enhancedSwitch.isSwitched();
  },

  setToggled(newToggledValue) {
    this.refs.enhancedSwitch.setSwitched(newToggledValue);
  },

  _handleToggle(e, isInputChecked) {
    if (this.props.onToggle) this.props.onToggle(e, isInputChecked);
  }
});




/** WEBPACK FOOTER **
 ** ./src/components/forms/toggle/Toggle.js
 **/